<template>
  <v-container fluid :class="containerClasses">
    <slot name="title"></slot>
    <v-layout row wrap :class="navigationClasses || 'mt-1 mb-2'" justify-center v-if="$slots['navigation-bar']">
      <slot name="navigation-bar"></slot>
    </v-layout>
    <v-layout row wrap id="dataTable" :class="rowClasses">
      <v-flex xs12 class="table-responsive">
        <table class="table">
          <thead v-if="tableHeader">
            <tr>
              <th v-for="item in tableHeader.split(',')" :key="`${item}Head`" class="k-orange-linear">
                {{ item }}
              </th>
            </tr>
          </thead>
          <slot name="header" v-else-if="$slots.header"></slot>
          <tbody v-if="(Array.isArray(items) ? !items.length : !Object.keys(items).length) && notMessageData">
            <tr>
              <td class="text-xs-center" :colspan="tableHeader.split(',').length">
                <v-icon x-large class="grey--text text--lighten-1">info_outline</v-icon> No se encontraron resultados
              </td>
            </tr>
          </tbody>
          <component @doEvent="doEvent" :is="content" :items="items" v-else @close="$emit('close')"></component>
        </table>
      </v-flex>
    </v-layout>
    <v-layout justify-center align-center v-if="!notMessageData && (Array.isArray(items) ? !items.length : !Object.keys(items).length)" class="vh-70">
      <v-flex md12>
        <v-flex md12 text-xs-center>
          <v-icon large>fas fa-info-circle</v-icon>&nbsp;&nbsp;&nbsp;
          <span class="ml-3 pt-3 f1-5em">No se encontraron resultados</span>
        </v-flex>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-4 mr-2 v-show="meta.total > limit">
      <v-flex xs12 text-xs-center>
        <v-btn
          @click.native="changePage('-')"
          :disabled="page === 1 || !page"
          class="pagination-button"
          icon
          small>
          <v-icon pt-5>fa-caret-left</v-icon>
        </v-btn>
        <template v-if="page > 4">
          <v-btn class="paginate-button elevation-0" @click="page = 1">
            1
          </v-btn>
          ...
        </template>
        <template v-if="page < 5">
          <v-btn class="paginate-button elevation-0" v-for="(item, i) in 5" :key="i" @click="page = item" :disabled="page === item" v-if="meta.last_page >= item">
            {{ item }}
          </v-btn>
        </template>
        <template v-for="item in 1" v-else>
          <v-btn class="paginate-button elevation-0" @click="page = page - item">
            {{ page - item }}
          </v-btn>
          <v-btn class="paginate-button elevation-0" disabled>
            {{ page }}
          </v-btn>
          <v-btn class="paginate-button elevation-0" v-if="page !== meta.last_page" @click="page = page + item">
            {{ page + item }}
          </v-btn>
        </template>
        <template v-if="page < meta.last_page - 1 && meta.last_page > 5">
          ...
          <v-btn class="paginate-button elevation-0" @click="page = meta.last_page">
            {{meta.last_page}}
          </v-btn>
        </template>
        <v-btn
          @click.native="changePage('+')"
          :disabled="meta.last_page === page"
          class="pagination-button"
          icon
          small>
          <v-icon pt-5>fa-caret-right</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import EventBus from '@/event-bus';

const _ = require('lodash');
const qs = require('qs');

export default {
  props: {
    url: String,
    fields: String,
    tableHeader: {
      type: String,
      default: '',
    },
    content: String,
    filters: Object,
    limit: Number,
    searchFields: {
      type: String,
      default: '',
    },
    searchOnCreate: {
      type: Boolean,
      default: true,
    },
    containerClasses: {
      type: String,
      required: false,
    },
    navigationClasses: {
      type: String,
      required: false,
    },
    rowClasses: {
      type: String,
      required: false,
    },
    customize: {
      type: Boolean,
      default: false,
    },
    notMessageData: {
      type: Boolean,
      default: true,
    },
    bus: {
      type: Object,
      default() {
        return {
          update: 'update',
          clearItems: 'cleaningItems',
          total: 'total',
        };
      },
    },
    applyUrlFilters: {
      type: Boolean,
      default: true,
    },
    refresh: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    EventBus.$on(this.bus.update, () => { // eslint-disable-line
      this.search();
    });
    EventBus.$on(this.bus.clearItems, () => {
      this.items = [];
      this.meta = {};
    });
    if (this.searchOnCreate) {
      this.search();
    }
  },
  destroyed() {
    EventBus.$off(this.bus.update);
    EventBus.$off(this.bus.clearItems);
  },
  mounted() {
    Array.from(document.getElementsByClassName('data-table-input')).forEach((element) => {
      element.addEventListener('blur', () => {
        if (!element.value) {
          this.page = 1;
        }
      });
    });
  },
  data() {
    return {
      cancelToken: {},
      page: 1,
      items: [],
      meta: {
        total: 0,
      },
    };
  },
  computed: {
    urlFilters() {
      let filters = {};
      if (this.filters) {
        filters = qs.stringify(Object.keys(this.filters).reduce((newObject, key) => {
          if (this.filters[key] || key === 'ignore_programmed') {
            // eslint-disable-next-line
            newObject[key] = this.filters[key];
          }
          return newObject;
        }, {}));
      } else {
        filters = '';
      }
      return filters;
    },
  },
  methods: {
    doEvent(data) {
      this.$emit(data.event, { ...data });
    },
    search(url = null, fields = null, searchFields = null) {
      if (!Object.keys(this.cancelToken).length) {
        this.cancelToken = this.axios.CancelToken.source();
      } else {
        this.cancelToken.cancel('');
        this.cancelToken = this.axios.CancelToken.source();
      }
      // eslint-disable-next-line
      this.axios.get(`${url || this.url}?${this.fields || fields ? `fields=${fields || this.fields}` : ''}${this.fields || fields ? '&' : ''}limit=${this.limit}&page=${this.page}${this.applyUrlFilters ? this.urlFilters ? `&${this.urlFilters}` : '' : `&${qs.stringify(this.filters)}`}${this.searchFields || searchFields ? `&search_fields=${searchFields || this.searchFields}` : ''}`, {
        cancelToken: this.cancelToken.token,
      })
        .then((response) => {
          this.items = response.data.data;
          if (response.data.meta) {
            this.meta = {
              total: response.data.meta.total,
              from: response.data.meta.from,
              to: response.data.meta.to,
              current_page: response.data.meta.current_page,
              last_page: response.data.meta.last_page,
            };
          } else {
            this.meta = {
              total: response.data.total,
              from: response.data.from,
              to: response.data.to,
              current_page: response.data.current_page,
              last_page: response.data.last_page,
            };
          }
        }).catch(() => {});
    },
    // eslint-disable-next-line
    searchData: _.debounce(function() { this.search(); }, 500),
    changePage(operator) {
      if (operator === '+') {
        this.page = parseInt(this.page, 10) + 1;
      } else {
        this.page = parseInt(this.page, 10) - 1;
      }
    },
  },
  watch: {
    filters: {
      handler(val) {
        this.page = 1;
        if (val.search === '') {
          this.search();
        } else {
          this.searchData();
        }
      },
      deep: true,
    },
    refresh(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.search();
      }
    },
    page: _.debounce(function(newVal, oldVal) { // eslint-disable-line
      this.search();
    }, 200),
    url(newVal) {
      this.search(newVal);
    },
    fields(newVal) {
      this.search(null, newVal);
    },
    searchFields(newVal) {
      this.search(null, null, newVal);
    },
  },
};
</script>

<style>
#dataTable .list {
  padding: 0;
}

#dataTable .list .list__tile {
  height: 80px;
}

#dataTable .theme--light .list .list__tile--link:hover {
  background: inherit !important;
}

#dataTable .pagination-button {
  width: 47px !important;
}

#dataTable .pagination-button {
  height: 48px !important;
}

.data-table-input {
  width: 30px !important;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/global/DataTable.vue